import { useMemo } from 'react';
import _ from 'lodash';

const useCurrentWatchlistId = (widgetSettings) => {
    return useMemo(() => _.get(widgetSettings, 'currentWatchlistId'), [widgetSettings]);
};

export default useCurrentWatchlistId;
